import { useMutation } from '@tanstack/react-query'

import { reinitPlayer } from '../../services'

import type { ReinitPlayerResponse } from '@/modules/session/type'
import type {
	UseMutationOptions,
	UseMutationResult,
} from '@tanstack/react-query'

type UseMutationReinitPlayerOptions = UseMutationOptions<
	ReinitPlayerResponse,
	Error,
	string
>

export default function useMutationReinitPlayer(
	options?: UseMutationReinitPlayerOptions,
): UseMutationResult<ReinitPlayerResponse, Error, string> {
	return useMutation({
		mutationFn: reinitPlayer,
		...options,
	})
}
